export default "__VITE_ASSET__CYAuRi4F__"